import m from "../../geodata/es2015/finlandHigh";
window.am4geodata_finlandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/finlandHigh.js
// module id = null
// module chunks = 